import { Button } from '@/components/ui/Button';
import { useT } from '@/lib/i18n';
import { setTheme, useTheme } from '@/lib/theme';

/** A moon (press for dark) and a sun (press for light), drawn inline: this button is in the first load, so no icon library. */
const MOON = 'M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z';
const SUN =
  'M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zM12 1v3M12 20v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M1 12h3M20 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1';

/**
 * The light / dark switch (D-343). The icon shows what you get by pressing it (a moon while the page is light), and the
 * button's name says the same in words. The site opens light; the choice is remembered on this device.
 */
export function ThemeToggle({ className }: { className?: string }) {
  const t = useT();
  const theme = useTheme();
  const toDark = theme === 'light';
  return (
    <Button
      type="button"
      variant="ghost"
      round
      className={className}
      aria-label={toDark ? t('theme.toDark') : t('theme.toLight')}
      onClick={() => {
        setTheme(toDark ? 'dark' : 'light');
      }}
    >
      <svg
        viewBox="0 0 24 24"
        width="20"
        height="20"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d={toDark ? MOON : SUN} />
      </svg>
    </Button>
  );
}
